module.exports = __webpack_public_path__ + "media/bootstrap-icons/check2-all-4e867530.svg";